import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IconsModule } from 'lib/modules/feather-icons.module';

interface ButtonOptions {
    text: string;
    type: 'primary' | 'secondary' | 'tertiary' | 'facet' | 'graph-swap' | 'tiny-primary' | 'tiny-use-case' | 'tag';
    iconPosition?: 'left' | 'right';
    iconName?: string;
    iconSize?: 'small' | 'medium' | 'large';
    iconStrokeWidth?: 'small' | 'medium' | 'large';
    disabled?: boolean;
    externalLink?: boolean;
    internalLink?: boolean;
    class?: string;
    unsetWidth?: boolean;
    innerTabIndex?: number;
}

@Component({
    selector: 'button-component',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [CommonModule, RouterModule, IconsModule],
})
export class ButtonComponent {
    @Input() buttonOptions: ButtonOptions = { text: '', type: 'primary' };
}
